<template>
    <div class="bread-crumbs">
        <ul class="crumbs-list d-flex py-3 px-0 m-0">
            <li
                v-for="(item,index) in items"
                :key="`${index}-${item}`"
                class="crumb-item p2n"
                :class="{
                'mx-3' : index > 0 && (index < items.length - 1),
                'c3': index === items.length - 1,
                'c4': index !== items.length - 1
                }">
                <span v-if="!item.link">{{item.title}}</span>
                <span v-else @click="$router.push(item.link)" class="link">
                    {{item.title}}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            items: Array
        },
        name: 'BreadCrumbs',
    }
</script>

<style lang="scss" scoped>
    .crumb-item {
        &:not(:last-child)::after{
            content: '>';
            margin-left: 5px;
        }
        .link {
            cursor: pointer;
            &:hover {
                color: #8DA0A9!important;
            }
        }
    }
</style>